// MENU_QR удалён
export const FirebaseWebScreens = {
  MENU_PERIODIC_TABLE: 'periodic_table',
  MENU_SEARCH: 'search',
  MENU_ELEMENT_LIST: 'element_list',
  MENU_TABLES: 'tables',
  MENU_CALCULATORS: 'calculators',
  MENU_SETTINGS: 'settings',
};

// источники QR-стены (web-only)
export const FirebaseQrSource = {
  MENU_CALCULATORS: 'menu_calculators',
  MENU_QR_BUTTON: 'menu_qr_button',
  SEARCH_PRO_FILTER: 'search_pro_filter',
  LIST_PRO_PROPERTY: 'list_pro_property',
  READ_PRO_ITEM: 'read_pro_item',
  READ_COMPARE: 'read_compare',
};




// --- Экраны (1:1 порт FirebaseBrainScreens.kt) ---
export const FirebaseBrainScreens = {
  // MAIN SCREEN
  FRAGMENT_GRID: 'fragment_grid',
  FRAGMENT_SEARCH: 'fragment_search',
  FRAGMENT_LIST: 'fragment_list',
  FRAGMENT_OTHER: 'fragment_other',
  FRAGMENT_TABLES: 'fragment_tables',

  // READ OTHER SIDE
  READ_FROM_CALC: 'calc',
  READ_FROM_WIDGET: 'widget',

  // MAIN GRID
  GRID_GO_PRO_BTN: 'go_pro_btn',
  GRID_TOOLBAR_PROPERTIES: 'toolbar_property',
  GRID_TOOLBAR_FAMILY: 'toolbar_family',
  GRID_TOOLBAR_FAMILY_CLEAR: 'toolbar_family_clear',
  GRID_TOOLBAR_QR: 'qr_start',
  GRID_TOOLBAR_QR_PRO: 'qr_start_pro',

  // DIALOGS
  DIALOG_GRID_PROPERTY: 'dialog_grid_property',
  DIALOG_LIST_PROPERTY: 'dialog_list_property',
  DIALOG_SEARCH_PROPERTY: 'dialog_search_property',

  // TABLES
  TABLES_SOLUBILITY: 'solubility',
  TABLES_EL_CONFIG: 'el_config',
  TABLES_INDICATORS: 'indicators',
  TABLES_ALKANES: 'alkanes',
  TABLES_POLY_AROMATIC: 'poly_aromatic',
  TABLES_QUALITATIVE: 'qualitative',
  TABLES_IONIZATION: 'ionization',
  TABLES_ACTIVITY_SERIES: 'activity_series',
  TABLES_EL_POTENTIAL: 'el_potential',
  TABLES_NEUTRON_CROSS: 'neutron_cross',
  TABLES_EL_NEGATIVITY: 'el_negativity',
  TABLES_GENERAL_CONSTANTS: 'general_constants',
  TABLES_DIPOLES: 'dipoles',
  TABLES_EMISSION_SPECTR: 'emission_spectr',

  // READ
  READ_ELEMENT_ACTIVITY: 'read_element',        // было 'read_element_screen' — ИСПРАВЛЕНО
  COMPARE_ELEMENT_ACTIVITY: 'compare_element',  // было 'compare_element_screen' — ИСПРАВЛЕНО
  READ_ELEMENT_INFO_ISOTOPE: 'all_isotope',
  READ_ELEMENT_INFO_ISOTOPE_TOOLBAR: 'all_isotope_toolbar',
  READ_ELEMENT_INFO_SHELL: 'shell',
  READ_ELEMENT_INFO_IMG: 'img_full',
  READ_ELEMENT_INFO_VS: 'vs',
  READ_ELEMENT_INFO_WIKI: 'wiki',
  READ_NAVIGATION_PREW: 'prev_element',
  READ_NAVIGATION_NEXT: 'next_element',
  READ_SOCIAL_FB: 'FB',
  READ_SOCIAL_IN: 'IN',
  READ_SOCIAL_TG: 'TG',

  // POPROSHAIKA
  POPROSHAIKA_POSITIVE_GOOGLE_PLAY: 'rate_positive_google_play',
  POPROSHAIKA_NEGATIVE_SEND_EMAIL: 'rate_negative_send_email',
  POPROSHAIKA_POSITIVE_EXIT: 'rate_positive_exit',
  POPROSHAIKA_NEGATIVE_EXIT: 'rate_negative_exit',

  // TRANSLATE
  TRANSLATE_HELP_YES: 'translate_yes',
  TRANSLATE_HELP_NO: 'translate_no',

  // OTHER V2
  OTHER_FRAGMENT_TERMS: 'terms',
  OTHER_FRAGMENT_NOTES: 'notes',
  OTHER_FRAGMENT_REACTIONS: 'reactions',
  OTHER_FRAGMENT_CALC_LIST: 'calc_list',
  OTHER_FRAGMENT_ISOTOPE: 'isotope',
  OTHER_FRAGMENT_QR: 'qr',
  OTHER_FRAGMENT_ACADEMY: 'academy',
  OTHER_FRAGMENT_SETTING: 'setting',
  OTHER_FRAGMENT_ABOUT: 'about',
  DEMO_CALC: 'demo_calc',
  OTHER_FRAGMENT_SHARE: 'share',

  // PAYWALL
  PAYWALL: 'paywall_mascot',
  PAYWALL_GROUPB_LOCAL: 'paywall_groupb_local',

  // ONBOARDING
  ONBOARDING_V1: 'onboarding_v1',
  ONBOARDING_V2: 'onboarding_v2',
  ONBOARDING_V2_WITH_PAYWALL: 'onboarding2_with_paywall',
  ONBOARDING_V2_WITH_PAYWALL_SKIP: 'onboarding2_with_paywall_skip',
};